import InfoRangeListTable from "./infoRangeListTable.container";

export default InfoRangeListTable;
